<template>
	<div class="text-grey"
	     style="clear: left; padding-top: .75em;">
		In het 4de kwartaal van 2025 komt de nieuwe verbetercheck gevaarlijke stoffen online. Tot die tijd moeten we
		helaas enkele onderdelen onder een disclaimer zetten. Als hier vragen over zijn neem dan contact op met een
		verbetercoach.
		<ul>
			<li>De veilige werkwijze Beitsen RVS en de Veilige werkwijze Kleinschalig kwasten en rollen met verf zijn
			    niet meer actueel en mogen niet meer worden gebruikt.
			</li>
			<li>Je mag maar maximaal 2 taken met een veilige werkwijzen per dag doen en de maximale tijd dat de taak per
			    dag mag worden uitgevoerd moet dan door 2 worden gedeeld.
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'HazardousSubstancesDisclaimer'
	};
</script>
